import {
  DELIVERY_FULFILLMENT,
  FulfillmentType,
  ORDER_AT_TABLE_FULFILLMENT
} from 'shop/types'
import { Fulfillment as CartFulfillment } from 'shop/types/cart'
import { getFulfillmentFlags } from 'shop/utils'
import { OrderFulfillmentType } from '../../Landing/types'
import { findDefaultFulfillment, formatMoney } from 'shop/utils/common'

/** Takes default fulfillment info & current cart info and returns vars for use in FulfillmentSummary */
export const getFulfillmentDetails = (
  cartFulfillment: CartFulfillment | null,
  defaultFulfillmentInfo: OrderFulfillmentType | null,
  isCartMatch: boolean
) => {
  const { isDelivery: cartIsDelivery, isOrderAtTable } = getFulfillmentFlags(
    cartFulfillment?.type
  )
  // Determine if we should use cart data
  const useCartData = isCartMatch && cartFulfillment

  const isDelivery = useCartData
    ? cartIsDelivery
    : defaultFulfillmentInfo?.fulfillmentType === DELIVERY_FULFILLMENT

  const defaultFulfillment = useCartData ? null : defaultFulfillmentInfo

  const fulfillmentWindow = useCartData
    ? cartFulfillment?.window
    : defaultFulfillment?.earliestTimeslot

  const orderType = useCartData
    ? cartFulfillment?.orderType
    : defaultFulfillment?.orderType

  const isOat = useCartData
    ? isOrderAtTable
    : defaultFulfillmentInfo?.fulfillmentType === ORDER_AT_TABLE_FULFILLMENT

  return { isDelivery, defaultFulfillment, fulfillmentWindow, orderType, isOat }
}

/** Extracts data for fulfillment toggle */
export const getFulfillmentToggleData = (
  toggleFulfillment: OrderFulfillmentType[] | null,
  type: FulfillmentType
) => {
  const fulfillment =
    toggleFulfillment && findDefaultFulfillment(toggleFulfillment, type)
  return {
    fulfillment,
    minValue: fulfillment?.minimumOrderValue
      ? `${formatMoney(fulfillment.minimumOrderValue, { stripTrailingZeros: true })} min fee`
      : 'No min fee'
  }
}
